exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".number-input {\n  width: 100%;\n}\n.number-input .ivu-input-number-handler-wrap {\n  display: none;\n}\n.number-input .ivu-input-number-input {\n  text-align: right !important;\n}\n", ""]);

// exports
